export default __webpack_public_path__ + "static/speechRecog-bec8eec480150cc2bc7c6e0d346364fd.png";